<template>
  <div>
    <div class="chat-sidebar focus">
      <div class="list-group text-left">
        <p class="text-center visible-xs">
          <a href="#" class="hide-chat btn btn-success">Hide</a>
        </p>
        <p class="text-center chat-title">Friends</p>
        <a
          @click="startChat(friend)"
          class="list-group-item"
          v-for="(friend, position) in friends"
          :key="friend.user_id"
        >
          <i
            :ref="(el) => (friendRefs[position] = el)"
            class="fa fa-check-circle absent-status"
          ></i>
          <img v-if="friend.avatar" :src="`http://localhost:9000/story/${friend.avatar.filename}`" class="img-chat img-thumbnail" />
          <img v-else src="img/Friends/guy-2.jpg" class="img-chat img-thumbnail" />
          <span class="chat-user-name">{{ friend.name }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  setup(_, context) {
    const store = useStore();
    const friends = ref([]);
    const userStatus = ref([]);
    const friendRefs = ref([]);

    onMounted(async () => {
      friends.value = await store.dispatch("friend/getFriends");
      await store.dispatch("friend/getFriendStatus", {
        token: localStorage.getItem("token"),
      });
    });
    store.subscribe((mutation, state) => {
      if (mutation.type === "friend/updateUserStatus" || mutation.type === "friend/fetchUserStatus") {
        userStatus.value = state.friend.onlineStatus;
      }
    });

    function startChat(friend) {
      context.emit("startChat", friend);
    }

    watch(
      userStatus,
      (newStatus) => {
        friendRefs.value.forEach((el, position) => {
          const friend = friends.value[position];
          const onlineStatus = newStatus.find(
            (status) => status.userID === friend.user_id
          );
          if (onlineStatus && onlineStatus.connected === true) {
            el.classList.remove("absent-status");
            el.classList.add("connected-status");
          } else {
            el.classList.remove("connected-status");
            el.classList.add("absent-status");
          }
        });
      },
      { deep: true }
    );

    return {
      friends,
      startChat,
      friendRefs,
    };
  },
};
</script>

<style scoped>
.chat-box {
  position: fixed;
  top: 51px;
  right: 0px;
  padding-top: 35px;
  padding-bottom: 15px;
  height: 95%;
  width: 210px;
  text-align: right;
  background-color: rgb(255, 255, 255);
  box-shadow: -3px 0px 3px 0px rgba(160, 160, 160, 0.3);
  z-index: 1000;
  overflow-y: auto;
}
</style>